import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Card from "../components/Card";

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[var(--bg-main)]">
      <Sidebar />
      <div className="flex-1 p-4 md:p-8 md:ml-64">
        <div className="mb-6">
          <button
            onClick={() => navigate("/settings")}
            className="mb-4 px-4 py-2 rounded-lg bg-surface-soft text-[var(--text-primary)] hover:bg-surface-soft transition-all"
          >
            Back to Settings
          </button>
          <h1 className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-[#22c55e] to-[#16a34a] bg-clip-text text-transparent">
            Terms of Service
          </h1>
          <p className="text-[var(--text-primary)] text-sm md:text-base">
            These terms govern use of the Aiarbix wallet and dashboard platform.
          </p>
        </div>

        <Card>
          <div className="space-y-4 text-[var(--text-primary)] text-sm">
            <p>
              By using this platform, you agree to follow account security,
              compliance, and lawful usage requirements.
            </p>
            <p>
              Users are responsible for keeping login credentials and 2FA codes
              secure. Unauthorized account sharing is not permitted.
            </p>
            <p>
              The platform may update terms as features evolve. Continued use
              implies acceptance of revised terms.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
